import script from "./BeginnerScheduling.vue?vue&type=script&setup=true&lang=js"
export * from "./BeginnerScheduling.vue?vue&type=script&setup=true&lang=js"

import "./BeginnerScheduling.vue?vue&type=style&index=0&id=2de51eb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2de51eb9"]])

export default __exports__